<template>
    <p class="error"><span v-for="e in ErrorList" v-bind:key="e">{{ e.Message }}<br /></span></p>
</template>

<script>
export default {
    name: "error-for",
    props: {
        field: {
            type: String,
            default: "",
        },
        errors: {
            type: Array,
            default: [],
        },
        fieldValue: {
            type: String,
            default: "",
        }
    },
    computed: {
        ErrorList: function () {
            let r = new Array();

            if (this.errors != null && this.errors.length > 0) {
                for (let i = 0; i < this.errors.length; i++) {
                    if (this.errors[i].Field == this.field) {
                        r.push(this.errors[i]);
                    }
                }
            }

            return r;
        }
    },
    watch: {
        fieldValue: function (newValue, oldValue) {
            if (this.errors == null || this.errors.length == 0) return;

            if (newValue != oldValue) {
                this.removeFieldErrors();
            }
        }
    },
    methods: {
        removeFieldErrors() {
            let errors = this.errors.filter(e => e.Field == this.field);
            if (errors && errors.length > 0) {
                errors.forEach(error => {
                    let index = this.errors.indexOf(error);
                    if (index >= 0) {
                        this.errors.splice(index, 1);
                    }
                });
            }
        },
    }
};
</script>